// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","top-panel":"top-panel_top-panel__mw2wS","hidden":"top-panel_hidden__ucL9y"};